import { swalErrorMessage } from "../../../../Constant/swalMessage";
import {
  addLeadsToWorkflowsService,
  getWorkflowsService,
  workflowService,
} from "../../services/workflow.services";

export const workflowAction = (data) => async () => {
  const res = await workflowService(data);
  if (res) {
    return res;
  } else {
    swalErrorMessage(res?.errMsg);
  }
};

export const getWorkflowsAction = (params) => async () => {
  const res = await getWorkflowsService(params);
  if (res?.status === 200) {
    return res?.data;
  }
};

export const addLeadsToWorkflowsAction = (payload) => async () => {
  const res = await addLeadsToWorkflowsService(payload);
  return res;
};
